module.exports = __webpack_public_path__ + "img/auburn-group.e82057a3.png";